import { Check, CheckCheck } from 'lucide-react';

// 3rd Party
import moment from 'moment';

// FutureLab
import { ChatListDataInterface, ChatParticipantsInterface } from '../ChatListItemsMobile';
import { ChatRoomItemsInterface } from '../ChatRoom';

interface ChatRoomMessageDetailsProps {
	loggedInUserParticipantId: ChatParticipantsInterface | undefined;
	chatItem: ChatRoomItemsInterface;
	chatInFocus: ChatListDataInterface;
}

export function ChatRoomMessageDetails(chatRoomMessageDetailsProps: ChatRoomMessageDetailsProps) {
	const { loggedInUserParticipantId, chatItem, chatInFocus } = chatRoomMessageDetailsProps;

	const returnFormattedTime = (time: string) => {
		return moment(time).format('h:mma');
	};

	return (
		<div className="min-w-0">
				{loggedInUserParticipantId?._id === chatItem?.participantId ||
				loggedInUserParticipantId?._id === chatItem?.participant ? (
					<div className="mb-3 ml-auto mr-11 mt-1.5 flex items-center justify-end gap-1 text-right text-[11px] text-slate-500">
						{returnFormattedTime(chatItem.createdAt)}
						{chatItem?.seenBy?.length >= chatInFocus?.participants.length ? (
							<CheckCheck className="read-receipt-font-size read-receipt-color inline" />
						) : (
							<Check className="read-receipt-font-size inline" />
						)}
					</div>
				) : (
					<div className="mb-3 mt-1.5 flex items-center gap-1 text-[11px] text-slate-500">
						{returnFormattedTime(chatItem.createdAt)}
						{chatItem?.seenBy?.length >= chatInFocus?.participants.length ? (
							<CheckCheck className="read-receipt-font-size read-receipt-color inline" />
						) : (
							<Check className="read-receipt-font-size inline" />
						)}
					</div>
				)}
		</div>
	);
}
